// Copyright (c) 2025-2026 One Great World LLC. All rights reserved.

import './SlideStyles.css'

function WelcomeSlide() {
  return (
    <div className="slide-content centered">
      <img src="./assets/logo.png" alt="Productivity Plus Pack" className="app-icon-large" />
      <h1 className="slide-title">Welcome to</h1>
      <h2 className="slide-subtitle brand">Productivity Plus Pack</h2>
      <p className="slide-text">
        Boost your Windows productivity with powerful tools designed to save you time
      </p>
      <div className="slide-meta">
        Press <kbd>→</kbd> or <kbd>Space</kbd> to continue
      </div>
    </div>
  )
}

export default WelcomeSlide
